<!--
 * @Description  : E签宝会员管理
 * @Author       : 王帅
 * @Date         : 2024-07-18 10:10:40
 * @LastEditors  : 王帅
 * @LastEditTime : 2025-10-14 16:11:11
 * @FilePath     : \ngs_platform_manage_admin\src\views\operation-management\es-member-management\index.vue
-->
<!--
    描述：会员管理
    时间：2022-06-22
    Created by zwh
-->
<template>
	<div class="es-main operation-layout" :class="{ pd0: !routeQuery }">
		<!-- 列表查询页 -->
		<filter-layout @search="doSearch" @reset="resetSearch" v-if="!routeQuery" :hasHeader="false" hasMore>
			<template #filter>
				<el-form class="flex-row-form colspan-4" size="small" ref="searchRef" :model="searchForm" label-width="110px">
					<el-form-item label="业务流水号：" prop="bizNumber">
						<el-input :placeholder="'请输入'" clearable v-model="searchForm.bizNumber"> </el-input>
					</el-form-item>
					<el-form-item label="会员名称：" prop="accountName">
						<el-input :placeholder="'请输入'" clearablev-model="searchForm.accountName"> </el-input>
					</el-form-item>
					<el-form-item label="会员类型：" prop="accountType">
						<el-select v-model="searchForm.accountType" :placeholder="'请选择'" clearable>
							<el-option v-for="(item, index) in accountTypeDL" :key="index" :value="item.code" :label="item.sname"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="证件类型：" prop="certType">
						<el-select v-model="searchForm.certType" :placeholder="'请选择'" clearable>
							<el-option v-for="(item, index) in certTypeDL" :key="index" :value="item.code" :label="item.sname"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</template>
			<template #more>
				<el-form class="flex-row-form colspan-4" size="small" ref="searchRef" :model="searchForm" label-width="110px">
					<el-form-item label="证件号：" prop="certNo">
						<el-input :placeholder="'请输入'" clearable v-model="searchForm.certNo"> </el-input>
					</el-form-item>
					<el-form-item label="发起日期" prop="dateArr" class="date-time">
						<el-date-picker
							v-model="searchForm.dateArr"
							type="daterange"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							value-format="yyyy-MM-dd"
						></el-date-picker>
					</el-form-item>
				</el-form>
			</template>
			<template #content>
				<!-- 非请求参数 正常查看 -->
				<div class="operation-main">
					<div class="operation-header">
						<div class="title">
							认证会员合计：<span class="blue">{{ tableObj.total }}</span> 个
						</div>
						<div class="btnGroups">
							<el-button type="primary" class="btn-blue" size="mini" @click="showTags('add')">
								发起认证
							</el-button>
						</div>
					</div>
					<div class="operation-container w-table-layout w-table-page">
						<div class="w-table-content" v-show="tableShow">
							<el-table ref="xTable" :data="tableObj.data" highlight-current-row height="100%" size="mini" border>
								<el-table-column type="index" label="" width="50" align="center"> </el-table-column>

								<el-table-column prop="bizNumber" label="业务流水号" align="center" width="180" show-overflow-tooltip>
								</el-table-column>
								<el-table-column prop="accountId" label="会员ID" align="center" width="180" show-overflow-tooltip></el-table-column>
								<el-table-column
									prop="accountName"
									label="会员名称"
									header-align="center"
									width="120"
									show-overflow-tooltip
								></el-table-column>
								<el-table-column prop="" label="会员类型" align="center" width="130" show-overflow-tooltip></el-table-column>
								<el-table-column prop="certType" label="证件类型" width="160" align="center" show-overflow-tooltip></el-table-column>
								<el-table-column prop="certNo" label="证件号" width="180" align="center" show-overflow-tooltip> </el-table-column>
								<el-table-column
									prop="mobileNo"
									label="手机号"
									width="180"
									header-align="center"
									show-overflow-tooltip
								></el-table-column>
								<el-table-column prop="flowId" label="授权认证流程ID" width="180" align="center" show-overflow-tooltip>
								</el-table-column>
								<el-table-column
									prop="createDate"
									label="流程发起时间"
									width="165"
									align="center"
									show-overflow-tooltip
								></el-table-column>
								<el-table-column align="center" width="100">
									<template slot="header">操作</template>
									<template slot-scope="scope">
										<!-- <span class="blue-text mr5"
                                      @click="showDeatil(scope.row)">
                                    <i class="el-icon-view"></i>详情
                                </span> -->
										<el-button
											type="primary"
											size="small"
											round
											plain
											class="table-btn"
											v-if="roleBtns.includes('memberDetail')"
											@click="showDetail(scope.row)"
										>
											<svg-icon icon-class="form-details"></svg-icon>
											详情
										</el-button>
									</template>
								</el-table-column>
							</el-table>
						</div>
						<div class="w-table-footer">
							<el-pagination
								@size-change="handleSizeChange"
								@current-change="handleCurrentChange"
								:current-page="tableObj.currentPage"
								:page-sizes="tableObj.pageList"
								:page-size="tableObj.pageSize"
								:total="tableObj.total"
								layout="total, sizes, prev, pager, next, jumper"
							>
							</el-pagination>
						</div>
					</div>
				</div>
			</template>
		</filter-layout>

		<!-- 详情页 -->
		<template v-else>
			<memberDetail ref="memberDetail"></memberDetail>
		</template>

		<!-- 发起认证等弹窗 -->
		<el-dialog
			:title="addDialogObj.title"
			:visible.sync="addDialogObj.visible"
			:width="addDialogObj.width"
			:close-on-click-modal="false"
			@close="addDialogClose"
			center
		>
			<!-- 弹窗组件 -->
			<div v-if="addDialogObj.visible" style="height: 350px">
				<initiateCertification
					ref="initiateCertification"
					v-if="addDialogObj.visible"
					@on-step-index="onStepIndex"
					@on-success="addDialogSuccess"
					@on-close="addDialogClose"
				></initiateCertification>
			</div>

			<!-- footer 组件 -->
			<div slot="footer" class="dialog-footer text-center">
				<!--
        <el-button size="small"
                   class="btn"
                   @click="addDialogObj.visible = false">取 消</el-button>
        -->
				<el-button type="primary" v-if="addDialogObj.stepIndex == 1" size="small" class="btn btn-blue" :loading="btnLoading" @click="nextStep"
					>下一步</el-button
				>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import initiateCertification from './components/initiate_certification_dialog'
import memberDetail from './components/detail'
import * as API from 'api/modules/es/member_manage'
export default {
	name: 'index',
	components: {
		initiateCertification,
		memberDetail
	},
	data() {
		return {
			btnLoading: false,
			searchToggle: true,
			tableShow: true,
			//会员类型下拉信息
			accountTypeDL: [],
			//证件类型
			certTypeDL: [],

			searchForm: {
				bizNumber: '',
				accountName: '',
				accountType: '',
				certType: '',
				certNo: '',
				dateArr: [],
				createStartDate: null,
				createEndDate: null
			},
			tableObj: {
				currentPage: 1, // 当前页码
				pageList: [10, 20, 50, 100], // 显示条数数组
				pageSize: 10, // 当前显示条数
				total: 0 // 当前总条数
			},

			addDialogObj: {
				title: '',
				visible: false,
				width: '600px',
				mode: 'add',
				stepIndex: 1
			}
		}
	},
	watch: {
		// 监听 筛选元素的 切换展示 重新调整表格高度
		searchToggle() {
			this.tableShow = false
			setTimeout(() => {
				this.tableShow = true
			}, 50)
			setTimeout(() => {
				this.$refs.xTable.doLayout()
			}, 1000)
		}
	},
	computed: {
		...mapState('app', { isBack: (state) => state.isBack }),
		...mapState('menu', {
			roleBtns: (state) => state.roleBtns
		}),
		routeQuery() {
			return this.$route.query.type
		}
	},
	created() {
		// 如果是 返回的
		if (this.isBack) {
			if (this.$getSessionItem('params')) {
				let params = JSON.parse(this.$getSessionItem('params'))
				Object.keys(this.searchForm).forEach((key) => (this.searchForm[key] = params[key]))
				this.tableObj.currentPage = params.currentPage
				this.tableObj.pageSize = params.pageSize

				// 移除 避免污染
				this.$removeSessionItem('params')
			}
		}
		this.getPageTableList()
	},
	methods: {
		//查询
		doSearch() {
			this.getPageTableList()
		},
		//获取分页列表信息
		getPageTableList() {
			this.tableObj.data = []
			if (this.searchForm.dateArr && this.searchForm.dateArr.length > 0) {
				this.searchForm.createStartDate = this.searchForm.dateArr[0] + ' 00:00:00'
				this.searchForm.createEndDate = this.searchForm.dateArr[1] + ' 23:59:59'
			} else {
				this.searchForm.createStartDate = ''
				this.searchForm.createEndDate = ''
			}
			let param = Object.assign({}, this.searchForm)

			param.current = this.tableObj.currentPage
			param.size = this.tableObj.pageSize

			API.getPageTableList(param).then((res) => {
				if (res.operationCode == 1) {
					this.tableObj.data = res.data.records
					this.tableObj.total = parseInt(res.data.total)
				}
			})
		},
		//按钮事件
		showTags(type) {
			if (type == 'add') {
				this.addDialogObj.title = '注册电子签章会员'
				this.addDialogObj.width = '680px'
				this.addDialogObj.visible = true
			}
		},
		onStepIndex(stepIndex) {
			this.addDialogObj.stepIndex = stepIndex
		},
		addDialogSuccess() {
			this.addDialogObj.visible = false
			this.addDialogObj.stepIndex = 1

			//刷新列表
			this.getPageTableList()
		},
		addDialogClose() {
			//this.$refs.initiateCertification.step2CallBackLoopTimer = null
			//重置2步骤获取 用户是否扫码验证 定时器
			this.$refs.initiateCertification.resetStep2Timer()
			this.addDialogObj.visible = false
			this.addDialogObj.stepIndex = 1

			this.getPageTableList()
		},
		//重置查询
		resetSearch() {
			Object.keys(this.searchForm).forEach((key) => (this.searchForm[key] = ''))
			this.searchForm.dateArr = []
			this.searchForm.createStartDate = null
			this.searchForm.createEndDate = null
			this.tableObj.pageSize = 10
			this.tableObj.currentPage = 1
			this.getPageTableList()
		},
		showDetail(row) {
			let params = Object.assign({}, this.searchForm)
			params.currentPage = this.tableObj.currentPage
			params.pageSize = this.tableObj.pageSize
			this.$setSessionItem('params', JSON.stringify(params))

			this.$router.push({
				name: 'Es-member-management-index',
				query: {
					type: 'memberDetail',
					id: row.id
				}
			})
		},
		// 切换显示条数
		handleSizeChange(val) {
			this.tableObj.pageSize = val
			this.getPageTableList()
		},

		//切换当前页码
		handleCurrentChange(val) {
			this.currentPage = val
			this.getPageTableList()
		},
		nextStep() {
			//this.addDialogObj.stepIndex++
			this.$refs.initiateCertification.nextStep()
		},

		// 返回
		goBack() {
			this.$router.push({ path: '/es-member-management-index' })
		}
	}
}
</script>

<style lang="less" scoped>
.es-main {
	&.pd0 {
		padding: 0;
	}
	.filter-box {
		padding-top: 5px;
	}

	/deep/ .search-form {
		.el-form-item {
			margin-bottom: 5px;
		}
	}

	.blue-text {
		color: #2671cc;
		cursor: pointer;
	}

	.blue-text:hover {
		color: blue;
	}

	.el-switch.is-disabled {
		opacity: 1;
	}

	/deep/ .el-switch.is-disabled .el-switch__core,
	/deep/ .el-switch.is-disabled .el-switch__label {
		cursor: pointer !important;
	}
}
.w-table-content {
	/deep/ .el-radio__label {
		display: none;
	}
}
.label-tooltip {
	max-width: 600px;
	max-height: 140px;
	overflow-y: auto;
	overflow-x: hidden;
}

.primary-dialog {
	/deep/ .el-dialog__body {
		padding: 30px;
	}

	.row-label {
		height: 40px;
		line-height: 40px;
		padding-right: 15px;
	}

	.row-btn {
		padding-left: 10px;
		width: 100%;
	}

	.tags-container {
		line-height: 40px;
		max-height: 120px;
		overflow-y: auto;

		/deep/ .el-tag {
			cursor: pointer;
		}
	}

	.tags-all-container {
		line-height: 30px;
		max-height: 300px;
		overflow-y: auto;

		/deep/ .el-tag {
			cursor: pointer;
		}
	}
}
</style>

<style lang="less">
.status {
	.switch > .el-switch__label--right > span {
		margin-left: 0 !important;
		margin-right: 15px !important;
	}
}
</style>
